<template>
  <!-- left_box -->
  <div id="left" class="col-md-3 col-xs-12 wow bounceInLeft">
    <div class="tab">
      <el-tabs v-model="activeName" type="card" @tab-click="handleClick">
        <el-tab-pane
          v-for="(item, index) in editableTabs"
          :label="item.title"
          :name="item.name"
          :key="index"
        >
        </el-tab-pane>
      </el-tabs>

      <div class="typemenu">
        <el-menu
          :default-active="String(active)"
          class="el-menu-vertical-demo"
          unique-opened
          @select="selectMenu"
        >
          <Submenu
            :list="typeList"
            :selectItem="active"
            :isshow="false"
            :active="activeName"
            @selectTop="selectMenu"
          ></Submenu>
        </el-menu>
      </div>
    </div>
  </div>
</template>

<script>
import Submenu from "./Submenu";
import {productType,industryType,sceneType} from '@/api/modules/product'
export default {
  name: "Navimg",
  data() {
    return {
      typeList: [],
      activeName: '0',
      active:'',
      editableTabs: [
        {
          title: this.$t("product.tabName1"),
          name: '0',
        },
        // {
        //   title: this.$t("product.tabName2"),
        //   name: '1',
        // },
        // {
        //   title: this.$t("product.tabName3"),
        //   name: '2',
        // },
      ],
    };
  },
  components: {
    Submenu,
  },
  mounted() {
    this.getProductType();
  },
  methods: {
    selectMenu(e) {
      console.log('32398====',e,this.activeName)
      this.$emit("selectType", {tab:this.activeName,id:e});
    },

    // 获取产品分类
    getProductType() {
      console.log('348348=======sdsdsdskey')
      productType(this.$store.getters.lang).then((res) => {
        if (res.returnCode == 200) {
          this.typeList = res.data;
          this.active= this.typeList[0].typeId
          this.$emit("selectType", {tab:this.activeName,id:this.active});
        }
      });
    },

    // 按行业分类
    getProjectType(){
      industryType(this.$store.getters.lang).then((res) => {
        if (res.returnCode == 200) {
          this.typeList = res.data;
          this.active= this.typeList[0].typeId
          this.$emit("selectType", {tab:this.activeName,id:this.active});
        }
      });
    },

    // 按场景分类
    getSceneType(){
      sceneType(this.$store.getters.lang).then((res) => {
        if (res.returnCode == 200) {
          this.typeList = res.data;
          this.active= this.typeList[0].typeId
          this.$emit("selectType", {tab:this.activeName,id:this.active});
        }
      });
    },

    handleClick(e,event) {
      console.log('2329=sdsdhhh-------------awsa',e.index,event)
      this.activeName=e.index
      this.$emit("changeValue");
      switch(Number(e.index)){
        case 0:
          this.getProductType()
        break;
        case 1:
          this.getSceneType()
        break;
        case 2:
          this.getProjectType()
        break;
      }
    },
  },
};
</script>

<style scoped>
.tab{
  /* width:100%; */
}
.left_box{
    background-color:#f4f4f4;
    width:30%;
    /* margin:0 15px; */
    padding:0 45px;
  }
/deep/ .el-menu{
  background-color:#f4f4f4;
}

/deep/ .el-tabs__nav{
  width:100%;
  display:flex;
  justify-content:space-around;
}

/deep/ .el-tabs--card>.el-tabs__header .el-tabs__item.is-active{
  border-bottom:4px solid #409eff;
}

/deep/ .el-tabs--card>.el-tabs__header .el-tabs__nav{
  border:none;
}

/deep/ .el-tabs--card>.el-tabs__header .el-tabs__item{
  border-left:none;
  font-size:18px;
}

.typetile {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 100px;
  /* background: linear-gradient(to bottom, #0c74b5 0%, #288fca 100%); */
}
.typetile-left {
  font-size: 30px;
  padding: 5px;
  font-weight: bold;
  color: #fff;
}
.typetile-rigth {
  padding: 15px;
  width: 45px;
  height: 45px;
  border: 1px solid #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
  border-radius: 50%;
}
.typetile-rigth img {
  width: 30px;
  height: 30px;
}
.typemenu {
  background-color: #fff;
}

.el-menu .el-menu-item,
.el-submenu {
  border-bottom: 1px solid #ebebeb; /* 给每个菜单项之间添加分隔线 */
  text-align: center;
}

.el-menu-item:last-child {
  border: none;
}
</style>



// WEBPACK FOOTER //
// src/components/productTypeLeft.vue